module.exports = __webpack_public_path__ + "img/refresh.d718f1a3.gif";